import styled from "styled-components";

export const DEComparisonTable = styled.div`
  width: 100%;
  margin-bottom: 1rem;

  ul {
    display: flex;
    flex-direction: row;
    padding: 0;
    margin: 0;

    &:nth-of-type(even) {
      background-color: #f7f8f8;
    }

    &:nth-of-type(odd) {
      background-color: #e9ecef;
    }
  }

  ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: left;
    padding: 10px;

    border-right: 1px solid #b3b0b0;
    margin: 0;

    &:nth-last-of-type(1) {
      border-right: 0;
    }

    &:nth-child(1) {
      width: 50%;
      padding-left: 1rem;
      display: block;
    }

    &:nth-child(n+2) {
      width: 16.6%;
      text-align: center;
    }

    &.question {
      align-items: flex-start;
    }

    p {
      margin: 0;
      font-size: 0.6rem;
    }

    &.title p {
      font-weight: bold;
    }

    svg {
      width: 10px;
    }
  }

  @media (min-width: 768px) {
    ul li {
      padding: 2rem 1rem;

      p {
        font-size: 1rem;
      }

      svg {
        width: 20px;
      }
    }
  }
`

export default DEComparisonTable;
